import config from "../config";

let snapshot = {
    accessToken: null,
    status: "unknown",
    user: null,
};
let refreshPromise = null;
const listeners = new Set();

function publish(next) {
    snapshot = { ...snapshot, ...next };
    listeners.forEach((listener) => listener());
}

async function parseResponse(response) {
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(body.detail || body.title || "认证请求失败");
        error.response = response;
        error.data = body;
        throw error;
    }
    return body;
}

export function setSession(payload) {
    publish({
        accessToken: payload.accessToken,
        status: "authenticated",
        user: payload.user,
    });
}

export function clearSession() {
    publish({ accessToken: null, status: "anonymous", user: null });
}

export function getAccessToken() {
    return snapshot.accessToken;
}

export function getAuthSnapshot() {
    return snapshot;
}

export function subscribeAuth(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export async function refreshSession() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = fetch(`${config.baseUrl}/auth/tokens`, {
        method: "POST",
        credentials: "include",
        headers: { Accept: "application/json" },
    })
        .then(parseResponse)
        .then((payload) => {
            setSession(payload);
            return payload;
        })
        .catch((error) => {
            clearSession();
            throw error;
        })
        .finally(() => {
            refreshPromise = null;
        });
    return refreshPromise;
}

export async function bootstrapSession() {
    if (snapshot.status !== "unknown") return snapshot;
    try {
        await refreshSession();
    } catch {
        // 没有刷新 Cookie 是正常的匿名状态。
    }
    return snapshot;
}
